import React from 'react';
// import photo1 from '../assets/photos/image1.jpeg'; 
import photo2 from '../assets/photos/image2.jpeg';
import photo3 from '../assets/photos/image3.jpeg';
import photo4 from '../assets/photos/image4.jpeg';
import photo5 from '../assets/photos/image5.jpeg'; 
import photo6 from '../assets/photos/image6.png'; 

const photos = [
  // { src: photo1, alt: 'Photo 1' },
  { src: photo2, alt: 'Photo 2' },
  { src: photo3, alt: 'Photo 3' },
  { src: photo4, alt: 'Photo 4' },
  { src: photo5, alt: 'Photo 5' }, 
  { src: photo6, alt: 'Photo 6' }, 
];

const Photos = () => {

  return (
    <div className="p-4">
      <div className="flex flex-row flex-wrap gap-4">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="overflow-hidden rounded-lg shadow-lg cursor-pointer"
          >
            <img src={photo.src} alt={photo.alt} className="max-w-[300px] max-h-[200px] object-cover protect-image" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Photos;
